/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { ClaimInfo } from './ClaimInfo';
import {
    ClaimInfoFromJSON,
    ClaimInfoFromJSONTyped,
    ClaimInfoToJSON,
    ClaimInfoToJSONTyped,
} from './ClaimInfo';

/**
 * 
 * @export
 * @interface UserClaimsResponse
 */
export interface UserClaimsResponse {
    /**
     * 
     * @type {Array<ClaimInfo>}
     * @memberof UserClaimsResponse
     */
    claims: Array<ClaimInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof UserClaimsResponse
     */
    claimCount?: number;
}

/**
 * Check if a given object implements the UserClaimsResponse interface.
 */
export function instanceOfUserClaimsResponse(value: object): value is UserClaimsResponse {
    if (!('claims' in value) || value['claims'] === undefined) return false;
    return true;
}

export function UserClaimsResponseFromJSON(json: any): UserClaimsResponse {
    return UserClaimsResponseFromJSONTyped(json, false);
}

export function UserClaimsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserClaimsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claims': (json['claims'] == null ? null : (json['claims'] as Array<any>).map(ClaimInfoFromJSON)),
        'claimCount': json['claimCount'] == null ? undefined : json['claimCount'],
    };
}

export function UserClaimsResponseToJSON(json: any): UserClaimsResponse {
    return UserClaimsResponseToJSONTyped(json, false);
}

export function UserClaimsResponseToJSONTyped(value?: UserClaimsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claims': (value['claims'] == null ? null : (value['claims'] as Array<any>).map(ClaimInfoToJSON)),
        'claimCount': value['claimCount'],
    };
}

